// extracted by mini-css-extract-plugin
export default {"two-column-grid":"TwoColumnGrid_two-column-grid__CZSv-","actionsRow":"TwoColumnGrid_actionsRow__bNql4"};